// Responsive styles for System Alert Bar component
// Keyframes are imported from systemAlertBar.css

export const getResponsiveStyles = (isMobile) => ({
  alertContainer: {
    position: 'fixed',
    top: 10,
    left: '50%',
    transform: 'translateX(-50%)',
    width: isMobile ? '90%' : 'auto',
    maxWidth: isMobile ? '95%' : '1000px',
    minWidth: isMobile ? '90%' : '800px',
    zIndex: 1001,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingLeft: isMobile ? '8px' : '16px',
    paddingRight: isMobile ? '8px' : '16px',
  },
  alertWrapper: {
    animationName: 'slideInDown',
    animationDuration: '0.4s',
    animationTimingFunction: 'ease-out',
    animationFillMode: 'both',
    transition: 'all 0.3s ease-in-out',
  },
  alertWrapperDismissing: {
    animation: 'fadeOut 0.3s ease-in',
    opacity: 0,
    maxHeight: 0,
    overflow: 'hidden',
  },
  alert: {
    marginBottom: 0,
    borderRadius: '8px',
    borderLeft: 'none',
    borderRight: 'none',
    borderTop: 'none',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)',
    padding: '6px 24px',
    fontSize: '14px',
    lineHeight: '22px',
    border: '1px solid rgba(0, 0, 0, 0.06)',
  },
  alertMessage: {
    fontWeight: 500,
  },
  linkButton: {
    fontWeight: 500,
    padding: '0 12px',
    height: '24px',
    lineHeight: '24px',
    fontSize: '14px',
  },
  closeButton: {
    marginLeft: '8px',
    padding: '2px',
    height: '24px',
    width: '24px',
    borderRadius: '4px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
    color: 'rgba(0, 0, 0, 0.45)',
    backgroundColor: 'transparent',
  },
  closeButtonHover: {
    backgroundColor: 'rgba(0, 0, 0, 0.06)',
    color: 'rgba(0, 0, 0, 0.75)',
  },
  hiddenIndicator: {
    padding: '6px 24px',
    backgroundColor: 'rgba(240, 242, 245, 0.98)',
    backdropFilter: 'blur(8px)',
    borderBottom: '1px solid rgba(5, 5, 5, 0.06)',
    borderRadius: '0 0 8px 8px',
    fontSize: '13px',
    color: 'rgba(0, 0, 0, 0.65)',
    textAlign: 'center',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    animationName: 'slideInDown',
    animationDuration: '0.4s',
    animationTimingFunction: 'ease-out',
    animationDelay: '0.2s',
    animationFillMode: 'both',
  },
  hiddenIndicatorIcon: {
    fontSize: '14px',
    color: '#1890ff',
  },
});
